import Vue from 'vue'
import Vuex from 'vuex'
import autenticacion from './modules/autenticacion.js'
import createLogger from 'vuex/dist/logger';

Vue.use(Vuex)

const debug = process.env.NODE_ENV !== 'production'

export default new Vuex.Store({
  modules: {
    autenticacion,
  },
  strict: debug,
  // plugins: debug? [ createLogger() ] : [],
  state: {
    view_name: '',
    user_rol: '',

  },
  mutations: {
    set_view_name(state, [current,previous]){
      state.view_name = current;
      state.user_rol = previous;
    }
  },
  getters: {
    view_name(state, getters){
      return state.view_name
    },
    user_rol(state, getters){
      return state.user_rol
    },
  }
})